import { useTranslation } from "react-i18next";
import minimize from "../../../assets/img/svg/sidebar/minimize.svg";
import enlargeSidebar from "../../../assets/img/svg/sidebar/enlarge-sidebar.svg";
import { useAppDispatch } from "../../../hook/useAppDispatch";
import { setIsSidebarMinimized } from "../../../store/slice/config/config";
import { useAppSelector } from "../../../hook/useAppSelector";

const Minimize: React.FC = () => {
  const isSidebarMinimized = useAppSelector(
    (state) => state.configSlice.isSidebarMinimized
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div
      className="sidebar_element_wrapper"
      onClick={() => dispatch(setIsSidebarMinimized())}
    >
      <span>
        <img
          src={isSidebarMinimized ? enlargeSidebar : minimize}
          alt="icon"
        ></img>
        <p className="title">{t(`${t("sidebar.minimize.title")}`)}</p>
      </span>
    </div>
  );
};

export default Minimize;
